import React from "react";

import Svg, { Path } from "components/Svg";

const ArrowLeft = props => (
	<Svg width={6 * props.scale} height={14 * props.scale} viewBox="0 0 6 14">
		<Path
			fill={props.fill || "black"}
			fillOpacity={props.opacity || "0.15"}
			d="M5 3.5v7q0 0.203-0.148 0.352t-0.352 0.148-0.352-0.148l-3.5-3.5q-0.148-0.148-0.148-0.352t0.148-0.352l3.5-3.5q0.148-0.148 0.352-0.148t0.352 0.148 0.148 0.352z"
		/>
	</Svg>
);

export default ArrowLeft;



// WEBPACK FOOTER //
// ./src/components/svgs/ArrowLeft/index.js